import { JSONContent } from '@tiptap/core';

import {
  hasTextInRichtext,
  isRichtextEmpty,
} from 'approot/shared/richtext/richtext.utils';
import { Table, TableCell, TableRow } from './table.constants';

export function getEditableCellsRowHeight(cells: TableCell[]) {
  let rows = 1;
  cells.forEach(cell => {
    // if there is richtext content determine if there are empty lines
    if (
      cell.value &&
      Object.keys(cell.value).length > 0 &&
      !hasTextInRichtext(cell.value)
    ) {
      rows = Math.max(cell.value.content.length, rows);
    }
  });
  return rows;
}

export function isCellEmpty(richtext?: JSONContent) {
  return (
    richtext && (isRichtextEmpty(richtext) || !hasTextInRichtext(richtext))
  );
}

export function getTableHeaderAndBodyRows(table: Table): {
  tableHeaderRow: TableRow | null;
  tableBodyRows: TableRow[];
} {
  const tableHeaderRow = table.showRowHeaders ? table.rows[0] : null;
  const tableBodyRows = table.showRowHeaders
    ? table.rows.filter((_, index) => index > 0)
    : table.rows;
  return {
    tableHeaderRow,
    tableBodyRows,
  };
}

export function calculateTableFixedValuesBasedOnContainer(
  containerWidth: number,
  columnWidths: number[]
) {
  const totalWidth = columnWidths.reduce((sum, width) => sum + width, 0);
  const ratio = totalWidth / containerWidth;
  return columnWidths.map(width =>
    Number(Math.floor(width / ratio).toFixed(0))
  );
}
